import React, { DragEvent, FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header/Header';
import SideNav from './SideNav/SideNav';
import './Layout.scss';
import Footer from './Footer/Footer';
import LoadingIcon from '../../library/components/LoadingIcon/LoadingIcon';
import GraphStatusSnackbar from '../../library/components/GraphStatusSnackbar/GraphStatusSnackbar';
import ROUTES from '../../library/constants/routeConstants';

// Exact list-page paths where AG Grid provides its own loading state — suppress the global overlay.
// Detail routes (e.g. /users/:userId, /reports/:id/:section) are intentionally excluded so they
// continue to show the global LoadingIcon while fetching.
const GRID_ONLY_PATHS = [
    ROUTES.HISTORY,
    ROUTES.DASHBOARD,
    ROUTES.REPORTS,
    ROUTES.USERS,
    ROUTES.TEAMS,
    ROUTES.ROLES,
    ROUTES.TENANTS,
    ROUTES.DATA_SOURCES,
    ROUTES.STATUS,
    ROUTES.QUERY_PAGE,
];

interface LayoutProps {
    children: JSX.Element
}

const Layout: FC<LayoutProps> = ({children}) => {
    const [sideNavOpen, setSideNavOpen] = useState(true);
    const { pathname } = useLocation();

    return <div className={`application-wrapper ${process.env.REACT_APP_SKIN_NAME}`}>
        <Header onMenuClick={() => setSideNavOpen(!sideNavOpen)} />
        <SideNav open={sideNavOpen} />
        <div
            className="component-wrapper"
            style={{ marginLeft: 50, marginRight: 50 }}
            onDragOver={(e: DragEvent<HTMLDivElement>) => {
                e.dataTransfer.effectAllowed = "move";
                e.dataTransfer.dropEffect = "move";
                e.preventDefault();
            }}
        >
            {!GRID_ONLY_PATHS.includes(pathname) && <LoadingIcon />}
            {children}
        </div>
        <Footer />
        <GraphStatusSnackbar />
    </div>;
}

export default Layout;